import { render } from "./DomesticOral.vue?vue&type=template&id=0b3745aa&ts=true"
import script from "./DomesticOral.vue?vue&type=script&lang=ts"
export * from "./DomesticOral.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__